// src/pages/PublishOverviewPage.js
import React from 'react';
import { Box, Typography, List, ListItem, Divider, Button} from '@mui/material';
import {  useNavigate, useOutletContext } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

type PublishOutletContext = {
  handleNavigateToStructure: () => void;
};

const PublishOverviewPage = () => {

  const { handleNavigateToStructure } = useOutletContext<PublishOutletContext>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
};

return (
  <Box  sx={{
    display: "flex",
    flexDirection: "column",
    minHeight: { xs: "calc(100vh - 120px)", sm: "90vh" }, // Ajustar altura en móvil
    px: { xs: 1, sm: 2 }, // Padding horizontal responsive
  }}>
    {/* Grid container for the left and right sections */}
    <Grid container spacing={4} sx={{ flexGrow: 1 }}>
      {/* Left Section: Title and Image */}
      <Grid size={{xs:12, md:6}} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '2rem', px:2 }}>
          Publica tu propiedad de forma rápida y sencilla siguiendo estos pasos
      </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <img
            src='/assets/images/publish1.jpg'
            alt="Publishing Overview"
            style={{ width: '70%', maxWidth: '600px', height: 'auto', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }} 
          />
        </Box>
      </Grid>
      
      {/* Right Section: Steps List */}
      <Grid size={{xs:12, md:6}} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' ,justifyContent: 'center' }}>
        <List>
          {/* Step 1 */}
          <ListItem sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, marginTop:2, bgcolor: '#f9f9f9', borderRadius: '8px', p: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginRight: 2, color: 'darkGreen' }}>1</Typography>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" fontWeight="bold">Describe tu propiedad</Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>Comparte algunos datos básicos sobre tu propiedad, como la ubicación y si la propiedad estará disponible para alquiler o venta.</Typography>
            </Box>
            <img src='/assets/images/overview1.png' alt="Step 1" style={{ width: '100px', marginLeft: 'auto', borderRadius: '8px' }} />
          </ListItem>
          <Divider />
          {/* Step 2 */}
          <ListItem sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, bgcolor: '#f9f9f9', borderRadius: '8px', p: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginRight: 2, color: 'darkGreen' }}>2</Typography>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" fontWeight="bold">Haz que destaque</Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>Agrega al menos cinco fotos, un título y una descripción. Nosotros te ayudaremos.</Typography>
            </Box>
            <img src='/assets/images/overview2.png' alt="Step 2" style={{ width: '100px', marginLeft: 'auto', borderRadius: '8px' }} />
          </ListItem>
          <Divider />
          {/* Step 3 */}
          <ListItem sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, bgcolor: '#f9f9f9', borderRadius: '8px', p: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginRight: 2, color: 'darkGreen' }}>3</Typography>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" fontWeight="bold">Publica tu anuncio</Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>Revisa la vista previa de tu publicación y haz clic en publicar. ¡Tu propiedad estará disponible para que otros lo vean!</Typography>
            </Box>
            <img src='/assets/images/overview3.png' alt="Step 3" style={{ width: '100px', marginLeft: 'auto', borderRadius: '8px' }} />
          </ListItem>
        </List>
      </Grid>
    </Grid>

    {/* Divider and Continue Button */}
    <Divider 
      sx={{ 
        mt: 4, 
        borderBottomWidth: 4, 
        borderColor: 'grey', 
        borderRadius: 3, 
      }} 
    />
    
    <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
      {/* Botón de "Ir atrás" alineado a la izquierda */}
      <Button
        variant="outlined"
        color="success"
        onClick={handleBack}
      >
        Ir atrás
      </Button>

      {/* Botón de "Comencemos" alineado a la derecha */}
      <Button
        variant="contained"
        color="success"
        onClick={handleNavigateToStructure}
      >
        Comencemos
      </Button>
    </Box>
  </Box>
);

};

export default PublishOverviewPage;
